export const services = [
  {
    id: 'esmaltado-permanente',
    name: 'Esmaltado permanente',
    durationMinutes: 60,
    description:
      'Preparación de la uña, aplicación de color y diseño a elección, finalizando con exfoliación.',
    price: 13000,
    priceType: 'from',
    image: '',
  },
  {
    id: 'kapping',
    name: 'Reforzamiento de uña natural / Kapping',
    durationMinutes: 90,
    description:
      'Preparación de la uña y una capa adicional de producto según sus necesidades para aportar grosor y resistencia, finalizando con diseño y exfoliación.',
    price: 17000,
    priceType: 'from',
    image: '',
  },
  {
    id: 'soft-gel',
    name: 'Soft Gel',
    durationMinutes: 120,
    description:
      'Preparación de la uña, aplicación de tips, nivelación, color, diseño y exfoliación.',
    price: 20000,
    priceType: 'from',
    image: '',
  },
  {
    id: 'pedicura',
    name: 'Pedicura',
    durationMinutes: 120,
    description:
      'Preparación de uñas, limpieza, exfoliación, tratamiento de durezas, hidratación y terminación según la modalidad elegida.',
    price: 15000,
    priceType: 'from',
    image: '',
  },
];

export const additionalServices = [
  { id: 'francesa', name: 'Francesa', price: 5000 },
  { id: 'degrade', name: 'Degradé', price: 3000 },
  { id: 'reparacion', name: 'Reparación de uñas', price: 3000 },
  { id: 'retiro', name: 'Retiro de productos', price: 5000 },
];
